import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import AnualidadAcumuladoResumen from "../../../../types/AnualidadAcumuladoResumen";
import { formatMoney } from "../../../helpers/formatters";

interface Props {
  resumen: AnualidadAcumuladoResumen;
  loading: boolean;
}

export const SnapshotResumen = ({ resumen, loading }: Props) => {
  const porcentajeColor = (porcentaje: number) => {
    if (porcentaje >= 100) return "success";
    if (porcentaje >= 75) return "warning";
    return "danger";
  };

  if (!resumen) {
    return null;
  }

  return (
    <div
      className="row mb-4 mt-4"
      style={{
        opacity: loading || !resumen ? 0.5 : 1
      }}
    >
      <Col md={3}>
        <Card className="border-primary">
          <CardBody>
            <h6 className="text-muted mb-2">
              Acumulado {resumen && resumen.club ? "del Club" : "de Clubes"}
            </h6>
            <h4 className="mb-0 text-primary">
              {resumen && resumen.acumulado ? (
                formatMoney(resumen.acumulado, 2)
              ) : (
                <>&nbsp;</>
              )}
            </h4>
            <small className="text-muted">
              {resumen && resumen.club
                ? `De club ${resumen.club}`
                : "Del periodo"}
            </small>
          </CardBody>
        </Card>
      </Col>
      <Col md={3}>
        <Card className="border-info">
          <CardBody>
            <h6 className="text-muted mb-2">Acumulado de Chaters</h6>
            <h4 className="mb-0 text-info">
              {resumen && resumen.acumuladoContactCenter ? (
                formatMoney(resumen.acumuladoContactCenter, 2)
              ) : (
                <>&nbsp;</>
              )}
            </h4>
            <small className="text-muted">Contact Center</small>
          </CardBody>
        </Card>
      </Col>
      <Col md={3}>
        <Card className="border-secondary">
          <CardBody>
            <h6 className="text-muted mb-2">
              Meta {resumen && resumen.club ? "del Club" : "de Clubes"}
            </h6>
            <h4 className="mb-0 text-secondary">
              {resumen && resumen.meta ? (
                formatMoney(resumen.meta)
              ) : (
                <>&nbsp;</>
              )}
            </h4>
            <small className="text-muted">Periodo mensual</small>
          </CardBody>
        </Card>
      </Col>
      <Col md={3}>
        <Card
          className={`border-${porcentajeColor(
            (resumen && resumen.porcentaje) || 0
          )}`}
        >
          <CardBody>
            <h6 className="text-muted mb-2">Porcentaje</h6>
            <h4
              className={`mb-0 text-${porcentajeColor(
                (resumen && resumen.porcentaje) || 0
              )}`}
            >
              {resumen && resumen.porcentaje ? (
                `${resumen.porcentaje.toFixed(2)}%`
              ) : (
                <>&nbsp;</>
              )}
            </h4>
            <small className="text-muted">Del total de ventas</small>
          </CardBody>
        </Card>
      </Col>
      <Col>
        <hr />
      </Col>
    </div>
  );
};
